import { render, staticRenderFns } from "./SampleOrdersForCollection.vue?vue&type=template&id=54220e34&scoped=true"
import script from "./SampleOrdersForCollection.vue?vue&type=script&lang=js"
export * from "./SampleOrdersForCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54220e34",
  null
  
)

export default component.exports